import { render, staticRenderFns } from "./config_total.vue?vue&type=template&id=5eb33782&scoped=true"
import script from "./config_total.vue?vue&type=script&lang=js"
export * from "./config_total.vue?vue&type=script&lang=js"
import style0 from "./config_total.vue?vue&type=style&index=0&id=5eb33782&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb33782",
  null
  
)

export default component.exports